// Column definitions for the domain coverage DataTable.
import React from "react";
import type { Column } from "../../../components/DataTable";
import type { DomainCoverage } from "../api/contentRegistryApi";
import { plainText } from "../utils";
import {
  DomainChip,
  SharePctBar,
  StrengthPill,
} from "./domainIntelligenceParts";
import {
  DOMAIN_COVERAGE_COL_HEADERS,
  DOMAIN_COVERAGE_COL_MIN_WIDTH,
} from "./utils/constants";
import {
  formatConfidenceScore,
  isDocumentShareEmpty,
} from "./utils/helpers";

export function getDomainCoverageColumns(): Column<DomainCoverage>[] {
  return [
    {
      key: "domainCode",
      header: DOMAIN_COVERAGE_COL_HEADERS.code,
      align: "left",
      headerAlign: "left",
      minWidth: DOMAIN_COVERAGE_COL_MIN_WIDTH.code,
      render: (row) => <DomainChip code={row.domainCode} />,
    },
    {
      key: "domainName",
      header: DOMAIN_COVERAGE_COL_HEADERS.name,
      align: "left",
      headerAlign: "left",
      minWidth: DOMAIN_COVERAGE_COL_MIN_WIDTH.name,
      ellipsis: 2,
      tooltip: (row) => plainText(row.domainName),
      render: (row) => (
        <span className="text-foreground break-words">
          {plainText(row.domainName)}
        </span>
      ),
    },
    {
      key: "policyRequirements",
      header: DOMAIN_COVERAGE_COL_HEADERS.requirements,
      align: "right",
      headerAlign: "right",
      minWidth: DOMAIN_COVERAGE_COL_MIN_WIDTH.requirements,
      render: (row) => (
        <span className="tabular-nums">{row.policyRequirements ?? 0}</span>
      ),
    },
    {
      key: "sharePct",
      header: DOMAIN_COVERAGE_COL_HEADERS.share,
      align: "left",
      headerAlign: "left",
      minWidth: DOMAIN_COVERAGE_COL_MIN_WIDTH.share,
      render: (row) => (
        <SharePctBar
          share={row.sharePct}
          conf={row.confidence}
          empty={isDocumentShareEmpty(row)}
        />
      ),
    },
    {
      key: "mappedClauseIds",
      header: DOMAIN_COVERAGE_COL_HEADERS.refs,
      align: "right",
      headerAlign: "right",
      minWidth: DOMAIN_COVERAGE_COL_MIN_WIDTH.refs,
      render: (row) => (
        <span className="tabular-nums">
          {row.mappedClauseIds?.length ?? 0}
        </span>
      ),
    },
    {
      key: "strength",
      header: DOMAIN_COVERAGE_COL_HEADERS.strength,
      align: "center",
      minWidth: DOMAIN_COVERAGE_COL_MIN_WIDTH.strength,
      render: (row) => <StrengthPill conf={row.confidence} />,
    },
    {
      key: "confidence",
      header: DOMAIN_COVERAGE_COL_HEADERS.confidence,
      align: "right",
      headerAlign: "right",
      minWidth: DOMAIN_COVERAGE_COL_MIN_WIDTH.confidence,
      render: (row) => (
        <span className="tabular-nums">{formatConfidenceScore(row.confidence)}</span>
      ),
    },
  ];
}
